// extracted by mini-css-extract-plugin
export default {"rect":"Highlight-module__rect__sRx0K"};